

export function getReportIcon(key: string): string {
  switch (key) {
    case ('crm'): {
      return 'dollar-sign';
    }
    case ('projects'): {
      return 'settings';
    }
    case ('batteries'): {
      return 'thermometer';
    }
    case ('route'): {
      return 'factory';
    }
    case ('finance'): {
      return 'dollar-sign'
    }
    case ('service'): {
      return 'wrench'
    }
    default: {
      return 'shopping-cart'
    }
  }
}
